const initialState = {
  messageSuccess: '',
  messageWarning: '',
};

export default function notificationReducer(state = initialState, action) {
  switch (action.type) {
    case 'NOTIFICATION_SUCCESS':
      return {
        ...state,
        messageSuccess: action.payload
      };
      case 'NOTIFICATION_WARNING':
      return {
        ...state,
        messageWarning: action.payload
      };
    default:
      return state
  }
}